export enum CommunicationEventType {
  NewInboundCommunication = 1,
  NewOutboundCommunication = 2,
  CommunicationRead = 3,
}
